import AddIcon from "@mui/icons-material/Add";
import { Box, Button, Divider, Stack } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import AppContainer from "../../components/containers/AppContainer";
import CustomBar from "../../components/customBar";
import CustomSnackbar from "../../components/customSnackBar/customSnackBar";
import DynamicTable from "../../components/dynamicTable";
import AppLoader from "../../components/loader/loader";
import { deletePromo, getAllPromo, updatePromo } from "../../services/promoFn";
import NavigationDrawer from "./../../components/navigationDrawer/index";
import PromoForm from "./PromoForm";
import TextInput from "../../components/textInput";
import { APP_ICONS } from "../../assets";

const tableHeader = [
  "TITLE",
  "CODE",
  "DISCOUNT",
  "START DATE",
  "END DATE",
  "ACTIVE",
  "ACTIONS",
];
const displayRows = [
  "title",
  "code",
  "discount",
  "startDate",
  "endDate",
  "isActive",
  "actions_btn",
];

const Promo = () => {
  const [searchValue, setSearchValue] = useState("");
  const [originalData, setOriginalData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [dialogOpen, setDialogOpen] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [editData, setEditData] = useState(null);

  const snackRef = useRef();

  console.log(searchValue, "searchValuesearchValuesearchValue");

  useEffect(() => {
    fetchPromos();
  }, []);

  const fetchPromos = async () => {
    setLoading(true);
    try {
      const response = await getAllPromo();
      const data = response?.data?.data || response?.data || [];
      const list = Array.isArray(data) ? data : [];
      const prepared = list.map((d) => ({
        ...d,
        discount:
          d.discountType === "percentage"
            ? `${d.discountValue}%`
            : `${d.discountValue}`,
        startDate: d.startDate ? String(d.startDate).split("T")[0] : "",
        endDate: d.endDate ? String(d.endDate).split("T")[0] : "",
      }));
      setOriginalData(prepared);
      setTableData(prepared);
    } catch (error) {
      console.error("Error fetching promos:", error);
      snackRef.current?.showMessage?.("Failed to fetch promos", "error");
      setTableData([]);
    } finally {
      setLoading(false);
    }
  };

  const openDialog = () => setDialogOpen(true);

  const handleEdit = (data) => {
    setEditData({
      _id: data._id,
      formData: {
        title: data.title,
        code: data.code,
        description: data.description,
        discountType: data.discountType || "percentage",
        discountValue: data.discountValue,
        startDate: data.startDate,
        endDate: data.endDate,
        isActive: data.isActive,
      },
    });
    setFormData({
      title: data.title,
      code: data.code,
      description: data.description,
      discountType: data.discountType || "percentage",
      discountValue: data.discountValue,
      startDate: data.startDate,
      endDate: data.endDate,
      isActive: data.isActive,
    });
    openDialog();
  };

  const handleDelete = async (id) => {
    if (!id) return;
    setLoading(true);
    try {
      const response = await deletePromo(id);
      if (response?.data?.status === "success") {
        snackRef.current?.isOpenSnack({
          snackType: "success",
          snackMessage: response.data.message,
        });
        fetchPromos();
      } else {
        snackRef.current?.isOpenSnack({
          snackType: "error",
          snackMessage: response?.data?.message || "Failed to delete",
        });
      }
    } catch (error) {
      console.error("Delete promo error:", error);
      snackRef.current?.showMessage("Failed to delete promo", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleChangeStatus = async (checked, row) => {
    if (!row?._id) return;
    setLoading(true);
    try {
      const payload = {
        // send minimal payload; backend may accept partial update
        ...row,
        isActive: checked,
      };
      const response = await updatePromo(payload, row._id);
      if (response?.data?.status === "success") {
        snackRef.current?.isOpenSnack({
          snackType: "success",
          snackMessage: response.data.message,
        });
        fetchPromos();
      } else {
        snackRef.current?.isOpenSnack({
          snackType: "error",
          snackMessage: response?.data?.message || "Failed to update status",
        });
      }
    } catch (error) {
      console.error("Status update error:", error);
      snackRef.current?.showMessage?.("Failed to update status", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDialogClose = (submitted) => {
    setDialogOpen(false);
    setEditData(null);
    setFormData({});
    if (submitted) fetchPromos();
  };

  useEffect(() => {
    if (!searchValue) {
      setTableData(originalData);
      return;
    }

    const search = searchValue?.toLowerCase();

    const filtered = originalData.filter((item) => {
      const title = item.title?.toLowerCase() || "";
      const code = item.code?.toLowerCase() || "";
      const description = item.description?.toLowerCase() || "";

      const startDate = item.startDate
        ? String(item.startDate)?.toLowerCase()
        : "";
      const endDate = item.endDate ? String(item.endDate)?.toLowerCase() : "";

      return (
        title?.includes(search) ||
        code?.includes(search) ||
        description?.includes(search) ||
        startDate?.includes(search) ||
        endDate?.includes(search)
      );
    });

    setTableData(filtered);
  }, [searchValue, originalData]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
  };
  return (
    <NavigationDrawer>
      <AppLoader isVisible={loading} />
      <CustomBar title={"Promos"} />

      <Box display={"flex"} justifyContent={"space-between"} mt={2} mb={2}>
        <Stack
          px={3}
          py={2}
          gap={2}
          direction={{ md: "row" }}
          alignItems={"center"}
        >
          <TextInput
            sx={{ flex: 1 }}
            placeholder={"Search Promo Code"}
            InputStartIcon={<img src={APP_ICONS.searhIcon} width={20} />}
            value={searchValue}
            onChange={handleSearchChange}
          />
        </Stack>
        <Button
          onClick={() => {
            setEditData(null);
            setFormData({});
            openDialog();
          }}
          startIcon={<AddIcon />}
          sx={{
            px: 0,
            py: 0.5,
            fontWeight: "medium",
            fontSize: "16px",
            fontFamily: "Poppins",
            textTransform: "none",
            position: "relative",
            overflow: "hidden",
            width: "120px",
            backgroundColor: "primary.main",
            color: "#fff",
            borderRadius: "12px",
            border: "2px solid transparent",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            "&:hover": {
              transform: "scale(1.05)",
              backgroundColor: "primary.main",
              boxShadow: "0 12px 25px rgba(139, 69, 19, 0.6)",
            },
            "&::before": {
              content: '""',
              position: "absolute",
              top: "0",
              left: "0",
              background: "linear-gradient(45deg, #8B4513, #D2691E)",
              borderRadius: "inherit",
              transform: "scale(0)",
              transition: "transform 0.3s ease",
              zIndex: "-1",
            },
            "&:hover::before": {
              transform: "scale(1)",
            },
          }}
        >
          Add
        </Button>
      </Box>

      <AppContainer>
        <Divider />
        <DynamicTable
          tableHeader={tableHeader}
          displayRows={displayRows}
          tableData={tableData}
          showPagination={true}
          showUserMenu={true}
          handleEdit={handleEdit}
          handleDelete={(row) => handleDelete(row._id)}
          handleChangeStatus={handleChangeStatus}
        />
      </AppContainer>

      <PromoForm
        open={dialogOpen}
        onClose={handleDialogClose}
        formData={formData}
        setFormData={setFormData}
        editData={editData}
        refreshList={fetchPromos}
      />

      <CustomSnackbar ref={snackRef} />
    </NavigationDrawer>
  );
};

export default Promo;
